import React from 'react';
import { IUser } from '../../../../Interfaces/responseTypes';
import useLanguagesHooks from '../../../Languages/setLanguage-hooks';
import UserAvatar from '../../../Avatars/UserAvatar/userAvatar';
import { HomeHeaderNavs } from '../../../../Interfaces/componentTypes';
import useUserDrawerHooks from '../UserDrawer/userDrawer-hooks';
import useHomeHeader from '../../../Headers/HomeHeader/homeHeader-hooks';
import CustomDialog from '../../../Dialog/customDialog';
import { LogoutIcon } from '../../../../Assets/Icons';
import styles from './homeDrawerMObile.module.scss';

interface IProps {
    user: IUser,
    onNavHandle: (title: HomeHeaderNavs) => void;
    active: HomeHeaderNavs,
    onCloseDrawer: () => void
};

const HomeDrawerMobile: React.FC<IProps> = (props) => {
    const { user, active, onNavHandle, onCloseDrawer } = props;
    const {homeNavs} = useHomeHeader();
    const {t} = useLanguagesHooks();
    const { userDrawerItems, dialogComponent, open, onClose, onOpenLogOutDialog } = useUserDrawerHooks();

    return (
        <>
            <div className={styles.container}>
                <div className={styles.avatarBox}>
                    <UserAvatar
                        user={user}
                    />
                </div>
                {/* <div className={styles.navItemBox}>
                    {
                        homeNavs.map((item, index) => {
                            return (
                                <div
                                    key={index}
                                    className={styles.item}
                                    onClick={() => {
                                        onNavHandle(item.id)
                                        onCloseDrawer()
                                    }}
                                >
                                    <img src={item.icon} alt={`${item.icon}.icon`} />
                                    <p
                                        className={active !== item.id ? styles.navItem : styles.navItemActive}
                                    >{item.title}</p>
                                </div>
                            )
                        })
                    }
                </div> */}
                <div className={styles.itemBox}>
                    {
                        userDrawerItems.map((el, index) => {
                            return (
                                <div className={styles.item} key={index} onClick={el.onClick}>
                                    <img src={el.icon} alt='icon' />
                                    <p className={styles.itemTitle}>{el.title}</p>
                                </div>
                            )
                        })
                    }
                </div>
                <div className={styles.logOutBox} onClick={onOpenLogOutDialog}>
                    <img src={LogoutIcon} alt='icon' />
                    <p className={styles.logOutText}>{t('Buttons.Log_Out')}</p>
                </div>
            </div>
            <CustomDialog
                open={open}
                onClose={onClose}
                children={dialogComponent}
            />
        </>
    )
}

export default HomeDrawerMobile
